module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./IndexView.jsx"));
	}, "PrinterLog");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PrinterLog!./src/pages/Printer/PrinterLog/IndexView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=PrinterLog!./src/pages/Printer/PrinterLog/IndexView.jsx
// module chunks = 43